/**
 * アルファベットと数字のみを許可し、記号を禁止する入力検証
 */

export const validateNameFormat = (name: string): boolean => {
  if (!name || typeof name !== 'string') {
    return false
  }

  // アルファベット（a-z, A-Z）と数字（0-9）のみを許可（単語間の半角スペースは許可）
  const nameRegex = /^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$/

  return nameRegex.test(name)
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const nameValidator = (_rule: any, value: string): Promise<void> => {
  if (!value || value.trim() === '') {
    return Promise.reject(new Error('Name is required!'))
  }

  if (!validateNameFormat(value)) {
    return Promise.reject(
      new Error('Name can only contain letters and numbers. ')
    )
  }

  return Promise.resolve()
}
